function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".messaging_svg__cls-2{fill:#f8f8f8}.messaging_svg__cls-4{fill:#fbc282}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M89.65 22.33H23.52A12.64 12.64 0 0010.88 35v27a12.64 12.64 0 0012.64 12.57h4.1A1.45 1.45 0 0129.07 76v12.35a1.44 1.44 0 002.55.93l12.06-14.2a1.47 1.47 0 011.11-.51h44.86a12.64 12.64 0 0012.64-12.64V35a12.64 12.64 0 00-12.64-12.67z",
  stroke: "#0e5b7c",
  strokeLinecap: "round",
  fill: "#6e9db0",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "messaging_svg__cls-2",
  x: 26.24,
  y: 55.95,
  width: 45.65,
  height: 4.8,
  rx: 2
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  className: "messaging_svg__cls-2",
  x: 26.24,
  y: 45.57,
  width: 60.69,
  height: 4.8,
  rx: 2
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  className: "messaging_svg__cls-2",
  x: 26.24,
  y: 35.2,
  width: 36.83,
  height: 4.8,
  rx: 2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M60.35 60.2h66.13a12.64 12.64 0 0112.64 12.64v27a12.64 12.64 0 01-12.64 12.64h-4.1a1.45 1.45 0 00-1.45 1.45v12.32a1.45 1.45 0 01-2.55.94L106.32 113a1.47 1.47 0 00-1.11-.51H60.35A12.64 12.64 0 0147.71 99.8v-27a12.64 12.64 0 0112.64-12.6z",
  strokeMiterlimit: 10,
  fill: "#f8f8f8",
  stroke: "#0e5b7c",
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  className: "messaging_svg__cls-4",
  x: 63.07,
  y: 73.07,
  width: 45.65,
  height: 4.8,
  rx: 2
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  className: "messaging_svg__cls-4",
  x: 63.07,
  y: 83.44,
  width: 60.69,
  height: 4.8,
  rx: 2
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  className: "messaging_svg__cls-4",
  x: 63.07,
  y: 93.82,
  width: 36.83,
  height: 4.8,
  rx: 2
});

function SvgMessaging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "messaging_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

export default SvgMessaging;